import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=4c2f0ab3&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=4c2f0ab3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f0ab3",
  null
  
)

export default component.exports